/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 10:00:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:33:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import TranslationEdit from "../translation-edit/TranslationEdit";
import { useCallback, useEffect, useState } from "react";
import { api } from "../../../services/api/api";
import { getTranslation } from "./activitySectorTrad";
import Switch from "../../switch/Switch";
/***/

/***/

/**
* TechnicianForm: Create/edit technician form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function ActivitySectorForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.ActivitySector,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
    
  const [languages, setLanguagesState] = useState<EasyTech.Language[]>([]);
  const [translations, setTranslations] = useState<any[] | null>(null);
  const langs = getTranslation();

  const prepTranslate = useCallback(() => {     
    const translation: any[] = [];

    if (!langs || !data || !languages || translations)
      return;

    languages.forEach((l: any) => {
      if (data === undefined || data.translations === undefined) return;
      const ts = data.translations.find((c: any) => c.language.label === l.label);
      let value = ts ? ts.label : null;
      if (langs && langs[l.isoCode] && langs[l.isoCode][data?.label])
        value = langs[l.isoCode][data?.label];
      translation.push({
        language: l,
        label: value
      });
    });
    if (translation.length !== 0)
      setTranslations(translation);
  }, [langs, data, languages, translations]);

  /**
  * useEffect: get compinfos list
  */
  useEffect(() => {
    api.get("users/languages")
      .then(ret  => {
        setLanguagesState(ret as EasyTech.Language[]);        
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  /***/

  /**
  * useEffect: get compinfos list
  */
  useEffect(() => {
    prepTranslate();
  }, [prepTranslate]);
  /***/

  return (
    <>
      <div className="field">
        <label htmlFor="label">{t("label")}</label>
        <input type="text"
                value={data?.label || ""}
                onChange={(e) => onChange("label", e.target.value)}
                className={`${(submitted && (!data || !data?.label)) && "error"}`}
                placeholder={t("Label")}/>
      </div>
      <div className="field">
        <label htmlFor="label">{t("odooId")}</label>
        <input type="text"
                value={data?.odooId || ""}
                onChange={(e) => onChange("odooId", e.target.value)}
                className={`${(submitted && (!data || !data?.label)) && "error"}`}
                placeholder={t("Odoo ID")}/>
      </div>
      <div className="field">
        <label htmlFor="translation">{t("Translation")}</label>
        <TranslationEdit key={data?.id} data={translations} onChange={(v) => onChange("translations", v)} languages={languages}/>
      </div>

      <div className="field">
        <label className="block text-sm font-medium text-gray-700 mb-1">{t("Enable")}</label>
        <Switch checked={data?.enabled}
            onChange={(e) => onChange("enabled", e)}/>
      </div>
    </>
  );
}
/***/
